module.exports = __webpack_public_path__ + "static/media/preview-preview-page-1.72d306b5.png";